import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import { Edit, UserAvatar } from '../../../../assets/icons'
import { Text1, Text2 } from '../../../../components/ui/text'
import { capitalizeEachWord } from '../../../../utils/stringsUtils'
import colors from '../../../../styled/colors'

const AppointmentSummaryCard = ({ turn, clinicName, onEdit, showEdit = false }) => {
	const dateLabel = turn?.fechaTurno || '-'
	const timeLabel = turn?.fechaTurnoDateTime
		? moment(turn.fechaTurnoDateTime).format('HH:mm')
		: '-'

	return (
		<Card>
			<CardMain>
				<Avatar>
					<UserAvatar color="#161616" />
				</Avatar>
				<Content>
					<Text1 size={14} weight={600} color={colors.text.titleText} margin={0}>{capitalizeEachWord(turn?.nombreProfesional || '-')}</Text1>
					<Text2 size={11} color={colors.text.secondaryText} margin={0}>
						{capitalizeEachWord(turn?.nombreEspecialidad || '-')} - {dateLabel} - {timeLabel}
					</Text2>
					<Text2 size={12} color={colors.text.secondaryText} margin={0}>{clinicName || '-'}</Text2>
				</Content>
			</CardMain>
			{showEdit && (
				<EditButton type="button" onClick={() => onEdit(turn)} aria-label="Editar turno">
					<Edit color="#161616" />
				</EditButton>
			)}
		</Card>
	)
}

const Card = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
	padding: 16px;
	border: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-radius: 8px;
	background: ${props => props.theme.colors.brand.white};
	width: 100%;
`

const CardMain = styled.div`
	display: flex;
	gap: 12px;
	min-width: 0;
	flex: 1;
`

const Avatar = styled.div`
	width: 28px;
	height: 28px;
	display: grid;
	place-items: center;
	flex-shrink: 0;
`

const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`

const EditButton = styled.button`
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	flex-shrink: 0;
`

export default AppointmentSummaryCard
